export enum Contexts {
  Login = 'login',
  Authentication = 'authentication',
  NotFound = 'notFound',
  HealthPlans = 'healthPlans',
  HealthPlansCategories = 'healthPlansCategories',
  DoctorConsultations = 'doctorConsultations',
  Pharmacies = 'pharmacies',
  Labs = 'labs',
  Scans = 'scans',
  ClinicServices = 'inClinicServices',
  Surgical = 'surgical',
  providerDiscounts = 'providerDiscounts',
}

type ContextToPageNameMap = {
  [key in Contexts]: string;
};

export const contextToPageNameMap: ContextToPageNameMap = {
  [Contexts.Login]: 'Login',
  [Contexts.Authentication]: 'Authentication',
  [Contexts.HealthPlans]: 'Health Plans',
  [Contexts.NotFound]: 'Not Found',
  [Contexts.HealthPlansCategories]: 'Health Plan Categories',
  [Contexts.DoctorConsultations]: 'Doctor Consultations',
  [Contexts.Pharmacies]: 'Pharmacies',
  [Contexts.Labs]: 'Labs',
  [Contexts.Scans]: 'Scans',
  [Contexts.ClinicServices]: 'InClinic Services',
  [Contexts.Surgical]: 'surgical',
  [Contexts.providerDiscounts]: 'Provider Discounts',
};
